import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ device }) => (device === 'desktop' ? '32' : '16')}px;
`;

export { Container };
